import { render } from "./UserRegister.vue?vue&type=template&id=2e2bc4e7&ts=true"
import script from "./UserRegister.vue?vue&type=script&lang=ts"
export * from "./UserRegister.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__